// extracted by mini-css-extract-plugin
module.exports = {"root":"root-3qxa8","header":"header-31y5_","label":"label-1Lwda"};